<!--
 * @Description: 添加商品组件
 * @Autor: txp
 * @Date: 2021-04-29 17:07:58
-->
<template>
  <div class="addorderproucttable">
    <el-dialog
      class="pub_dialog"
      title="添加商品弹框"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      :lock-scroll="false"
      :destroy-on-close="true"
      width="80%"
    >
      <div class="dialogs" style="height:460px">
        <div class="flex">
          <div class="mr40">
            <span class="ft16 C787878">产品名称：</span>
            <el-input
              placeholder="产品名称"
              style="width:200px;"
              size="small"
              clearable
              @change="change"
              v-model="formData.productName"
            ></el-input>
          </div>
          <div class="mr40">
            <span class="ft16 C787878">产品编码：</span>
            <el-input
              placeholder="产品编码"
              style="width:200px;"
              size="small"
              clearable
              v-model="formData.productCode"
            ></el-input>
          </div>
          <el-button type="primary" size="small" @click="searchEvt()"
            >搜索</el-button
          >
        </div>
        <div
          v-loading="loading"
          style="height: 400px"
          element-loading-spinner="el-icon-loading"
        >
          <TableConent :table_config="table_config" ref="tableConent" />
          <div class="pageschange" v-if="total > 0">
            <el-pagination
              background
              layout="total,prev, pager, next"
              :total="total"
              prev-text="上一页"
              next-text="下一页"
              @next-click="nextClick"
              @prev-click="prevClick"
              @current-change="currentClick"
            ></el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="Cancel">取 消</el-button>
        <el-button size="small" type="primary" @click="Save">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableConent from './TableConent'
import {
  AvailableList,
  getTableConfig,
  FindFeePoolGoodsProductGroupList,
  ShoppingcartList,
  rebateGoodsList,
} from '@/api/api'
import { Storage } from '@/utils/storage'
import cals from '../js/cals'
export default {
  name: 'addorderproucttable',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    modelType: String,
  },
  data() {
    return {
      formData: {
        productCode: '',
        productName: '',
      },
      tableDataList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      table_config: {
        thead: [],
        checkbox: true, //是否显示多选
        table_data: [],
        isBorder: false, //是否需要边框线
        children: false, // 是否树形
      },
      input1: null, // 筛选框1
      input2: null, // 筛选框2
      loading: false,
    }
  },
  components: {
    TableConent,
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
      },
    },
  },
  created() {
    this['getConfig' + this.modelType]()
    let selectedProducts = cals.handleSubmitCal()
    selectedProducts = [
      ...selectedProducts[0].backList,
      ...selectedProducts[0].giftList,
      ...selectedProducts[0].normalList,
    ].map((item) => item.productCode)
    this.formData.ext40 = selectedProducts.join(',')
    this.handleRequest()
  },
  methods: {
    // 设置产品名称宽度
    setTableSellWidth(){
      let thead = this.table_config.thead
      thead.forEach(v=>{
        if(v.field === 'productName'){
          v.width = '300px'
        }else if(v.field === 'poolCode'){
          v.width = '160px'
        }
      })
      this.table_config.thead = thead
    },
    // 按条件搜索
    searchEvt() {
      this.pageNum = 1
      this.handleRequest()
    },
    change() {
      // console.log(123);
    },
    // 取消
    Cancel() {
      this.$emit('resetPopupData')
    },
    // 确定
    Save() {
      const data = this.$refs.tableConent.$refs.tableconentId.selection
      this.$emit('submitPopupData', data)
    },
    // 关闭
    handleClose() {
      this.$emit('handleClose')
    },
    // 获取选中的值
    handleSelectionChange(val) {
      this.favoriteIdArr = val
    },
    // 获取可够配置
    getConfig0() {
      const params = {
        functionCode: 'dms_check_product',
        parentCode: 'CRM20210129000000857_1',
      }
      this.table_config.children = false
      getTableConfig(params).then((res) => {
        if (res.success) {
          const tableList = []
          res.result.column.forEach((v) => {
            const rowData = v
            if (rowData.field !== 'checkTypecheckbox') {
              rowData.label = rowData.title
              rowData.prop = rowData.field
              tableList.push(rowData)
            }
          })
          this.table_config.thead = tableList.filter((item) => item.visible)
          this.setTableSellWidth()
        }
      })
    },
    // 获取货补配置
    getConfig2() {
      const params = {
        functionCode: 'dms_goods_product',
        cusCode: Storage.l.get('customerCode'),
        parentCode: 'CRM20210129000000857_1',
      }
      this.table_config.children = true
      getTableConfig(params).then((res) => {
        if (res.success) {
          const tableList = []
          res.result.column.forEach((v) => {
            const rowData = v
            if (rowData.field !== 'checkTypecheckbox') {
              rowData.label = rowData.title
              rowData.prop = rowData.field
              tableList.push(rowData)
            }
          })
          this.table_config.thead = tableList
          this.setTableSellWidth()
        }
      })
    },

    // 获取购物车配置
    getConfig3() {
      const params = {
        functionCode: 'dms_car_product',
        cusCode: Storage.l.get('customerCode'),
        parentCode: 'CRM20210129000000857_1',
      }
      this.table_config.children = false
      getTableConfig(params).then((res) => {
        if (res.success) {
          const tableList = []
          res.result.column.forEach((v) => {
            const rowData = v
            if (rowData.field !== 'checkTypecheckbox' && rowData.visible) {
              rowData.label = rowData.title
              rowData.prop = rowData.field
              tableList.push(rowData)
            }
          })
          this.table_config.thead = tableList
          this.setTableSellWidth()
        }
      })
    },

    // 获取常够配置
    getConfig4() {
      const params = {
        functionCode: 'dms_favorites_product',
        parentCode: 'CRM20210129000000857_1',
      }
      this.table_config.children = false
      getTableConfig(params).then((res) => {
        if (res.success) {
          const tableList = []
          res.result.column.forEach((v) => {
            const rowData = v
            if (rowData.field !== 'checkTypecheckbox') {
              rowData.label = rowData.title
              rowData.prop = rowData.field
              tableList.push(rowData)
            }
          })
          this.table_config.thead = tableList
          this.setTableSellWidth()
        }
      })
    },
    // 获取常够配置
    getConfig5() {
      this.getConfig4()
    },
    // 获取常够配置
    getConfig6() {
      this.getConfig4()
    },
    // 获取可购数据
    availablelist() {
      const params = {
        cusCode: Storage.l.get('customerCode'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.formData,
        ext40: '',
      }
      this.loading = true
      AvailableList(params).then((res) => {
        if (res.success) {
          this.loading = false
          this.table_config.table_data = res.result.data
          this.total = res.result.count
        }
      })
    },
    // 获取常够数据
    favoriteslist() {
      const params = {
        cusCode: Storage.l.get('customerCode'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ofenFlag: 1,
        ...this.formData,
        ext40: '',
      }
      this.loading = true
      AvailableList(params).then((res) => {
        if (res.success) {
          this.loading = false
          this.table_config.table_data = res.result.data
          this.total = res.result.count
        }
      })
    },
    // 获取货补数据
    getPoolList() {
      const params = {
        customerCode: Storage.l.get('customerCode'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        conditionType: 'sale_price',
        goodsProductCode: this.formData.productCode,
        goodsProductName: this.formData.productName,
      }
      this.loading = true
      FindFeePoolGoodsProductGroupList(params).then((res) => {
        if (res.success) {
          this.loading = false
          const list = cals.analysisGoods(res.result.data)
          console.log(list)

          this.table_config.table_data = list
          this.total = res.result.count
        }
      })
    },
    // 获取购物车数据
    getCarList() {
      let params = {}
      if (this.modelType === '3') {
        params = {
          customerCode: Storage.l.get('customerCode'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          goodsName: this.formData.productName,
          goodsCode: this.formData.productCode,
        }
      } else {
        params = {
          customerCode: Storage.l.get('customerCode'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          ...this.formData,
          ext40: '',
        }
      }

      this.loading = true
      ShoppingcartList(params).then((res) => {
        if (res.success) {
          this.loading = false
          const list = cals.analysisCar(res.result)
          console.log(list)
          this.table_config.table_data = list
        }
      })
    },
    // 添加返利项商品和现金垫付商品
    getRebateGoodsList() {
      const params = {
        customerCode: Storage.l.get('customerCode'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.formData,
        ext40: '',
      }
      this.loading = true
      rebateGoodsList(params).then((res) => {
        if (res.success) {
          this.loading = false
          // const list = cals.analysisCar(res.result.data);
          this.table_config.table_data = res.result.data
        }
      })
    },
    // 判断使用的接口
    handleRequest() {
      if (this.modelType === '2') {
        this.getPoolList()
      } else if (this.modelType === '3') {
        this.getCarList()
      } else if (this.modelType === '4') {
        this.favoriteslist()
      } else if (this.modelType === '5' || this.modelType === '6') {
        this.getRebateGoodsList()
      } else {
        this.availablelist()
      }
    },
    // 分页处理
    nextClick(nextPageNum) {
      this.loading = true
      this.pageNum = nextPageNum
      this.handleRequest()
    },
    prevClick(prevPageNum) {
      this.loading = true
      this.pageNum = prevPageNum
      this.handleRequest()
    },
    currentClick(currentPageNum) {
      this.loading = true
      this.pageNum = currentPageNum
      this.handleRequest()
    },
  },
}
</script>
<style lang="scss" scoped>
.addorderproucttable {
  /deep/.el-dialog__body {
    padding: 20px;
  }
  .pageschange {
    margin: 20px auto 0px;
    text-align: center;
  }
  .flex {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
}
</style>
